import { create } from 'zustand';
import { ObservePositionState } from './types';

const useInScreenViewStore = create<ObservePositionState>(set => ({
  observableComponents: {},
  setObservableComponents: ({ index, inView }) => {
    set(state => {
      const newObservableComponents = { ...state.observableComponents };
      const component = newObservableComponents[index];

      if (component) {
        component.isInView = inView;
      } else {
        newObservableComponents[index] = { isInView: false };
      }
      set({ observableComponents: newObservableComponents });
      return newObservableComponents;
    });
  },
}));

export default useInScreenViewStore;
